// extracted by mini-css-extract-plugin
module.exports = {"boxItemImage":"GalleryItem_boxItemImage__XBwoH","boxItemImageFull":"GalleryItem_boxItemImageFull__4hykW","description":"GalleryItem_description__QP7jO"};